import Context from 'managers/Context';
import { URL_IMAGE, PATH_IMAGE } from 'constants/Environment';
import { isBackendFalsy } from '@Sage/ssm-utils/backendScalars';
import Cookies from 'js-cookie';

// Base64 optimized placeholder for account chip avatar (20x20)
const PLACEHOLDER_ACCOUNT_CHIP_BASE64 =
    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMiIgZmlsbD0iI0YyRjJGMiIvPjxwYXRoIGZpbGw9ImdyYXkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE2LjggNy4wNDNDMTYuOCA2LjQ2OCAxNi4zMiA2IDE1LjczMyA2SDguMjY3QzcuNjc4IDYgNy4yIDYuNDY4IDcuMiA3LjA0M3Y5LjkxM2MwIC41NzYuNDc4IDEuMDQ0IDEuMDY3IDEuMDQ0aDEuNjI2YS4yNjQuMjY0IDAgMCAwIC4yNjYtLjI2di0yLjIwOGEuNTMuNTMgMCAwIDEgLjUzNC0uNTIzaDIuNjI2YS41My41MyAwIDAgMSAuNTM0LjUyMnYyLjIwOGMwIC4xNDQuMTIuMjYxLjI2Ny4yNjFoMS42MTNjLjU4OCAwIDEuMDY3LS40NjggMS4wNjctMS4wNDRWNy4wNDNaTTEwLjg5MyAxOGgyLjIxNHYtMi4yNWgtMi4yMTRWMThabTQuNDMtMTAuNWgtMS40NzdWOWgxLjQ3N1Y3LjVabTAgMi42MjVoLTEuNDc3djEuNWgxLjQ3N3YtMS41Wm0wIDIuNjI1aC0xLjQ3N3YxLjVoMS40Nzd2LTEuNVptLTQuMDYyIDBoMS40Nzd2MS41aC0xLjQ3N3YtMS41Wm0xLjQ3Ny0yLjYyNWgtMS40Nzd2MS41aDEuNDc3di0xLjVaTTguNjc3IDEyLjc1aDEuNDc3djEuNUg4LjY3N3YtMS41Wk0xMS4yNiA3LjVoMS40NzdWOWgtMS40NzdWNy41Wm0tMS4xMDcgMEg4LjY3N1Y5aDEuNDc3VjcuNVptLTEuNDc3IDIuNjI1aDEuNDc3djEuNUg4LjY3N3YtMS41WiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGgyNHYyNEgweiIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg==';

const getUserConfigData = () => {
    let config = {
        token: Context?.config?.token,
        strCellPhoneNumber: Context?.config?.userData?.user,
        impersonatedUser: Context?.config?.userData?.impersonatedUser,
        imageTimestamp: Cookies.get('imageTimestamp'),
    };

    config.userPictureUrl = `${URL_IMAGE}GetUserPicture.ashx?userKey=JWT ${config.token}&strCellPhoneNumber=${config.strCellPhoneNumber}&getbytes=true`;
    config.imageUrl = `${URL_IMAGE}GetImage.ashx?userKey=JWT ${config.token}&strCellPhoneNumber=${config.strCellPhoneNumber}&getbytes=true`;

    config.imageUrl = `${config.imageUrl}&impersonatedUser=${config.impersonatedUser}`;
    config.userPictureUrl = `${config.userPictureUrl}&impersonatedUser=${config.impersonatedUser}`;

    return config;
};

//Circle Avatar
export const getSrcUserCircleAvatar = (id, fallbackSrc) => {
    const { userPictureUrl, imageTimestamp } = getUserConfigData();
    const src = !isBackendFalsy(id)
        ? `${userPictureUrl}&idUser=${id}&timeStamp=${imageTimestamp}`
        : undefined;
    fallbackSrc = fallbackSrc || `${PATH_IMAGE}placeholder_user.svg`;

    return {
        src,
        fallbackSrc,
    };
};

export const getSrcContactCircleAvatar = (id, fallbackSrc) => {
    const { imageUrl } = getUserConfigData();
    const src = !isBackendFalsy(id) ? `${imageUrl}&idContact=${id}` : undefined;
    fallbackSrc = fallbackSrc || `${PATH_IMAGE}placeholder_user.svg`;

    return {
        src,
        fallbackSrc,
    };
};

export const getSrcCompanyCircleAvatar = (id, fallbackSrc) => {
    const { imageUrl } = getUserConfigData();
    const src = !isBackendFalsy(id) ? `${imageUrl}&idAccount=${id}` : undefined;
    fallbackSrc = fallbackSrc || PLACEHOLDER_ACCOUNT_CHIP_BASE64;

    return {
        src,
        fallbackSrc,
    };
};

export const getSrcProductCircleAvatar = (id, fallbackSrc, width, height) => {
    const { imageUrl } = getUserConfigData();
    let src = !isBackendFalsy(id) ? `${imageUrl}&idImage=${id}` : undefined;
    if (width && height && src) src += `&width=${width}&height=${height}`;
    fallbackSrc = fallbackSrc || `${PATH_IMAGE}no_image.png`;

    return {
        src,
        fallbackSrc,
    };
};

//Chip Avatar (Squared)
export const getSrcUserChipAvatar = (id, fallbackSrc) => {
    const { userPictureUrl } = getUserConfigData();
    const src = !isBackendFalsy(id) ? `${userPictureUrl}&idUser=${id}` : undefined;
    fallbackSrc = fallbackSrc || `${PATH_IMAGE}placeholder-user-chip.svg`;

    return {
        src,
        fallbackSrc,
    };
};

export const getSrcContactChipAvatar = (id, fallbackSrc) => {
    const { imageUrl } = getUserConfigData();
    const src = !isBackendFalsy(id) ? `${imageUrl}&idContact=${id}` : undefined;
    fallbackSrc = fallbackSrc || `${PATH_IMAGE}placeholder-user-chip.svg`;

    return {
        src,
        fallbackSrc,
    };
};

export const getSrcCompanyChipAvatar = (id, fallbackSrc) => {
    const { imageUrl } = getUserConfigData();
    const src = !isBackendFalsy(id) ? `${imageUrl}&idAccount=${id}` : undefined;
    fallbackSrc = fallbackSrc || `${PATH_IMAGE}placeholder-account-chip.svg`;

    return {
        src,
        fallbackSrc,
    };
};

export const getSrcCompanyChipAlternative = (id, fallbackSrc) => {
    const { imageUrl } = getUserConfigData();
    const src = !isBackendFalsy(id) ? `${imageUrl}&idImage=${id}` : undefined;
    fallbackSrc = fallbackSrc || `${PATH_IMAGE}placeholder-account-chip.svg`;

    return {
        src,
        fallbackSrc,
    };
};
